module.exports = __webpack_public_path__ + "img/box3_img2_dark.868c07b8.png";